// DIAS FESTIVOS BANCARIOS
// I. El 1 de enero.
// II. El primer lunes de febrero en conmemoración del 5 de febrero.
// III. El tercer lunes de marzo en conmemoración del 21 de marzo.
// IV. Jueves y Viernes santo.
// V. El 1 de mayo.
// VI. El 16 de septiembre.
// VII. El 2 de noviembre. Adicionalmente, el tercer lunes de noviembre en conmemoración del 20 de
// noviembre.
// VIII. El 12 y 25 de diciembre.
// IX. Los sábados y domingos

const moment = require('moment')

var DIAS_FIJOS = [
  { dia: '01', mes: '01', celebracion: 'Año Nuevo' },
  { dia: '01', mes: '05', celebracion: 'Día del Trabajo' },
  { dia: '16', mes: '09', celebracion: 'Día de la Independencia' },
  { dia: '02', mes: '11', celebracion: 'Fieles difuntos' },
  { dia: '12', mes: '12', celebracion: 'Día del empleado bancario' },
  { dia: '25', mes: '12', celebracion: 'Navidad' }
]

var SEMANA_SANTA = [
  { dia: -3, daysToSum: 7, celebracion: 'Jueves Santo' },
  { dia: -2, daysToSum: 7, celebracion: 'Viernes Santo' }
]

var MILLISECONDS_DAY = 86400000

class Festivos {
  static esDiaInhabil (date) {
    let dateObject = date
    if (date) {
      if (typeof (date) === 'object') {
        dateObject = moment(date, 'YYYY-MM-DD').toDate()
      } else {
        let firstDigits = date.substr(0, date.indexOf('/'))
        if (firstDigits.length === 0) {
          firstDigits = date.substr(0, date.indexOf('-'))
        }
        if (firstDigits.length === 2) {
          dateObject = moment(date, 'DD-MM-YYYY').toDate()
        }
        if (firstDigits.length === 4) {
          dateObject = moment(date, 'YYYY-MM-DD').toDate()
        }
      }

      let festivos = this.getFestivosPorAnio(dateObject.getUTCFullYear())

      // Sabado o domingo?
      if ((dateObject.getDay() === 0 || dateObject.getDay() === 6)) return true

      // Festivo?
      festivos = festivos.map(item => item.fecha)
      dateObject = moment(dateObject).format('YYYY-MM-DD')

      if (festivos.includes(dateObject)) return true
    }
    return false
  }

  static getFestivosPorAnio (anio) {
    if (!anio) {
      throw new Error('Año no especificado')
    } else {
      anio = anio.toString()
      if (!anio.match(/^\d*$/g)) {
        throw new Error('El año debe ser numero')
      } else if (anio < 1900 || anio > 3000) {
        throw new Error('Año debe ser entre 1900 y 3000')
      } else {
        // Dias festivos fijos
        var festivosFijos = DIAS_FIJOS.map((element, index, array) => {
          return {
            fecha: anio.toString().concat('-', element.mes, '-', element.dia),
            celebracion: element.celebracion
          }
        })

        // Dias festivos de semana santa
        var domingoPascua = new Date(this.butcherAlgorithm(anio))

        var festivosSemanaSanta = SEMANA_SANTA.map((element, index, array) => {
          var dia = new Date(domingoPascua.getTime() + element.dia * MILLISECONDS_DAY)
          return {
            fecha: this.getFormattedDate(dia.getUTCFullYear(), dia.getUTCMonth() + 1, dia.getUTCDate()),
            celebracion: element.celebracion
          }
        })

        // Dias festivos variables
        var festivosVariables = []

        // II. El primer lunes de febrero
        const constitucion = this.getLunes(new Date(anio, 1, 1))[0]
        // III. El tercer lunes de marzo
        const natalicio = this.getLunes(new Date(anio, 2, 1))[2]
        // VII. El tercer lunes de noviembre
        const revolucion = this.getLunes(new Date(anio, 10, 1))[2]

        festivosVariables.push({
          fecha: this.getFormattedDate(constitucion.getUTCFullYear(), constitucion.getUTCMonth() + 1, constitucion.getUTCDate()),
          celebracion: '1er lunes, conmemoración del 5 de febrero'
        }, {
          fecha: this.getFormattedDate(natalicio.getUTCFullYear(), natalicio.getUTCMonth() + 1, natalicio.getUTCDate()),
          celebracion: '3er lunes, conmemoración del 21 de marzo'
        }, {
          fecha: this.getFormattedDate(revolucion.getUTCFullYear(), revolucion.getUTCMonth() + 1, revolucion.getUTCDate()),
          celebracion: '3er lunes, conmemoración del 20 de noviembre'
        })

        var festivos = festivosFijos.concat(festivosSemanaSanta, festivosVariables)
        return festivos.sort((a, b) => {
          return new Date(a.fecha) - new Date(b.fecha)
        })
      }
    }
  }

  static butcherAlgorithm (anio) {
    var year = parseInt(anio)
    var A = year % 19
    var B = Math.floor(year / 100)
    var C = year % 100
    var D = Math.floor(B / 4)
    var E = B % 4
    var F = Math.floor((B + 8) / 25)
    var G = Math.floor((B - F + 1) / 3)
    var H = (19 * A + B - D - G + 15) % 30
    var I = Math.floor(C / 4)
    var K = C % 4
    var L = (32 + 2 * E + 2 * I - H - K) % 7
    var M = Math.floor((A + 11 * H + 22 * L) / 451)
    var N = H + L - 7 * M + 114
    var month = Math.floor(N / 31)
    var day = 1 + (N % 31)
    return this.getFormattedDate(year, month, day)
  }

  static nextDay (day, sum) {
    var date = new Date(day)
    var newDate = (sum === 7 ? date : new Date(date.getTime() + (((7 + sum) - date.getUTCDay()) % 7) * MILLISECONDS_DAY))
    return this.getFormattedDate(newDate.getUTCFullYear(), newDate.getUTCMonth() + 1, newDate.getUTCDate())
  }

  static addZero (number) {
    number = number.toString()
    if (number > 0 && number < 10 && !number.startsWith('0')) {
      return '0'.concat(number)
    } else {
      return number
    }
  }

  static getFormattedDate (year, month, day) {
    return year.toString().concat('-').concat(this.addZero(month)).concat('-').concat(this.addZero(day))
  }

  static getLunes (fecha) {
    const mes = fecha.getMonth()
    const lunesArr = []

    fecha.setDate(1)

    // Primer lunes
    while (fecha.getDay() !== 1) {
      fecha.setDate(fecha.getDate() + 1)
    }

    // Los lunes restantes
    while (fecha.getMonth() === mes) {
      lunesArr.push(new Date(fecha.getTime()))
      fecha.setDate(fecha.getDate() + 7)
    }

    return lunesArr
  }
}

module.exports = Festivos
